module.exports = __webpack_public_path__ + "img/VisualiseData.4aa0db30.gif";